import React, { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import Icon from 'components/Icon'
import { useDeleteItem } from 'hooks'
import { addModal } from 'features/modals/modalSlice'
import { deleteNavigationItem } from '../graphql/mutation'
import ContextMenu from './ContextMenu'
import NavSubMenuItemEditor from './NavSubMenuItemEditor'
import OptionButton from './OptionButton'
import { NavigationMenu } from '.'

const S = {
    Wrapper: styled(ContextMenu.Wrapper)`
        cursor: pointer;
        display: flex;
        align-items: center;
        padding: 5px;
    `,
    Label: styled(ContextMenu.Trigger)`
        white-space: nowrap;
        background: transparent;
        font-size: 16px;
        color: rgba(45, 48, 53, 0.75);
        margin: -8px;
        padding: 8px;
    `,
}

interface Props {
    item: NavigationMenu['subMenus'][0]['items'][0]
    onDeleted: () => void
}

const NavSubMenuItem = ({ item: initItem, onDeleted, ...dragHandleProps }: Props) => {
    const dispatch = useDispatch()
    const [item, setItem] = useState(initItem)
    const { showDeleteConfirmModal } = useDeleteItem(deleteNavigationItem, onDeleted)
    const showEditItemModal = useCallback(() => {
        dispatch(addModal({
            Component: ({ close }: { close: () => void }) => (
                <NavSubMenuItemEditor
                    close={close}
                    onSubmitted={(updatedItem) => setItem(updatedItem)}
                    navMenuItem={{
                        id: item.id,
                        title: item.text,
                        spaceId: item.space.id,
                        linkedSpaceId: item.linkedSpace?.id
                    }}
                />
            ),
            shouldNotWrap: true
        }))
    }, [dispatch, item.id, item.linkedSpace?.id, item.space.id, item.text])

    const handleDelete = useCallback(() => {
        showDeleteConfirmModal(item.id)
    }, [item.id, showDeleteConfirmModal])

    return (
        <S.Wrapper>
            <div {...dragHandleProps}>
                <Icon icon="dragVertical" style={{ marginBottom: 2 }} />
            </div>
            <S.Label>
                {item.text}

                <ContextMenu.Container>
                    <OptionButton icon="edit" onClick={showEditItemModal} />
                    <OptionButton icon="trash" onClick={handleDelete} />
                </ContextMenu.Container>
            </S.Label>
        </S.Wrapper>
    )
}

export default NavSubMenuItem
